import FormLabel from './FormLabel.vue';
export default {
  components: {
    'form-label': FormLabel
  },
  inject: {
    getContainer: { default: null },
    modelState: { default: null }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    validationHint: {
      type: String,
      default: ''
    },
    formTag: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      default: true
    },
    orientation: {
      type: String,
      default: null
    },
    value: {},
    noWrappers: {
      type: Boolean,
      default: false
    },
    preventFormChange: {
      type: Boolean,
      default: false
    },
    isVisible: {
      default: true
    },
    component:{},
    overrideLabelCss: {
      default: null
    },
    overrideInputCss: {
      default: null
    },
    info: {
      type: String,
      default: null
    },
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      formType: '',
      infoIcon: { height: '18px' }
    };
  },
  computed: {
    validationError () {
      let label = this.label;
      if(!this.modelState){
        return;
      }
      
      let state = this.modelState(this.formTag);
      if(!state){
        return;
      }
      
      if (this.modelState) {
				if(state && state.length){
					let copiedState = [...state];

					for (let index = 0; index < copiedState.length; index++) {
						const val = copiedState[index];
						let replacement = this.formTag;
						if (label) {
							let translated = val.replaceAll(replacement, label);
							copiedState[index] = translated;
						}
          }
					return copiedState.join(`  `);
				}
        return state;
      }
    },
    parent () {
      if (this.getContainer != null) {
        return this.getContainer();
      }
    },
    parentEnabled () {
      if (this.parent) {
        return this.parent.enabled;
      } else {
        return true;
      }
    },
    parentOrientation () {
      if (this.parent) {
        return this.parent.orientation;
      }
    },
    computedOrientation () {
      let orientation = 'vertical';
      if (this.parentOrientation) {
        orientation = this.parentOrientation;
      }
      if (this.orientation) {
        orientation = this.orientation;
      }
      return orientation;
    },
    isEnabled () {
      return (this.parentEnabled && this.enabled);
    },
    labelCssClass () {
      if (this.overrideLabelCss) {
        return this.overrideLabelCss;
      }
      if (this.noWrappers) {
        return {
          'd-none': (this.label === null || this.label.length === 0)
        };
      }
      return {
        'd-none': (this.label === null || this.label.length === 0),
        'col-md-12': this.computedOrientation === 'vertical',
        'col-md-4': this.computedOrientation === 'horizontal'
      };
    },
    inputCssClass () {
      if (this.overrideInputCss) {
        return this.overrideInputCss;
      }
      if (this.noWrappers) {
        return {
          'disabled': this.isEnabled === false
        };
      }
      return {
        'col-md-12': this.computedOrientation === 'vertical',
        'col-md-8': this.computedOrientation === 'horizontal',
        'disabled': this.isEnabled === false
      };
    },
    infoIconLabel () {
        return 'col';
    },
    infoIconWrapper () {
      if(this.computedOrientation === 'horizontal'){
        return 'align-self-center px-0';
      }
      return 'align-self-center';
    }
  },
  methods: {
    emitFormChange () {
      const self = this;
      this.$nextTick(() => {
        if (self.parent) self.parent.emitFormChange(self);
      });
    },
    async visible () {
      // if (this.visibleFunc) {
      //   let val = await this.visibleFunc();
      //   if (typeof (val) === 'boolean') return val;
      //   if (typeof (val) === 'function') return val(this.value);
      // }
      // return true;
    },
    async refreshVisible() {
      // this.isVisible = await this.visible();
    },
    /**
     * Select item using keyboard
     */
    onReturn (e) {
      this.$emit('on-return', this);
    }
  },
  watch: {
    visibleFunc: {
      handler: function (newvalue, oldvalue) {
        this.refreshVisible();
      },
      immediate: true
    }
  }
};
